import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IconEye } from "@pentabd/icons";
import { Button, Table } from "@pentabd/ui";

import { ButtonGroup } from "@components";
import { TableColumn } from "./TableColumn";

import { usePromotionsData } from "@hooks/HRM/promotions/usePromotions";
import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";
import { TablePagination } from "@helpers/tablePagination";

import { ROUTES } from "@constants/routes";
import { STATUS } from "@constants/status.hrm";

const { DRAFT, IN_PROGRESS, APPROVED, REJECTED, ACTION_NEEDED } = STATUS;

export const PromotionListTable = () => {
  const [activeStatus, setActiveStatus] = useState(0);

  const { t } = useTranslation();
  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const {
    data: promotionGroupList,
    pagination,
    handleQuery,
  } = usePromotionsData();
  const { total } = pagination || {};

  const filterButtons = t("RETIREMENT_LIST.TABLE.ACTION_BUTTONS", {
    returnObjects: true,
  }) as string[];

  const btnGroupAction = (index: number) => {
    let statusId = null;
    setActiveStatus(index);

    switch (index) {
      case 0:
        statusId = null;
        break;
      case 1:
        statusId = DRAFT;
        break;
      case 2:
        statusId = IN_PROGRESS;
        break;
      case 3:
        statusId = APPROVED;
        break;
      case 4:
        statusId = REJECTED;
        break;
      case 5:
        statusId = ACTION_NEEDED;
        break;
      default:
        statusId = null;
        break;
    }
    handleQuery("status", statusId as any);
  };

  return (
    <div className="mt-10">
      <Table
        columns={TableColumn(t)}
        rows={promotionGroupList}
        header={{
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },
          title: t("PROMOTION_LIST.TABLE.HEADER.LABEL"),
          buttons: [
            getAccess(roles, "PROMOTION_INITIATE") ? (
              <Link to={ROUTES.HRM.PROMOTION_CANDIDATES}>
                <Button size="sm" fill="outline" type="light">
                  <IconEye size="20" />
                  {t("PROMOTION_LIST.TABLE.HEADER.BUTTON_TEXT")}
                </Button>
              </Link>
            ) : (
              <></>
            ),
          ],
        }}
        headerExtension={{
          leftComponents: [
            <ButtonGroup
              key="btn-group"
              btnGroupData={filterButtons}
              activeState={activeStatus}
              action={btnGroupAction}
            />,
          ],
        }}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};
